import axios from "axios";
import {appdata} from "../../logic_tmp/appdata/AppData";

export async function testNodeConnector() {
    let body = {
        "action": "ResolveGeo",
        "myIp":"93.189.158.30",
        "mock": true,
        "points": {"A": {"y": 59.438870, "x": 24.7466389}, "B": {"y": 59.437091, "x": 24.746048}}
    }
    let resp = await call(body)
    if (resp.status !== 200)
        throw Error("unexpected status: " + resp.status)

}

export async function call(body) {
    let url = "https://api.duoclassico.eu/duonode"
    let ret
    if (body.myIp === undefined)
        body.myIp = appdata.myIp
    await axios.post(url, body).then(response => {
        if (response.status === 200) {
            ret = response;
        }
    })
    return ret;
}
